import React from 'react';

export interface CamaraIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CamaraIcon: React.FC<CamaraIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" clip-path="url(#a)"><path d="M23.246 19.162a2 2 0 0 1-2 2h-18a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><path d="M12.246 17.162a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.246.162h24v24h-24z"/></clipPath></defs>
    </svg>
  );
};

export default CamaraIcon;
